import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const PaymentCancelled = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    mt: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Cancel color="error" sx={{ fontSize: 64, mb: 2 }} />
                <Typography variant="h4" gutterBottom>
                    Payment Cancelled
                </Typography>
                <Typography align="center" color="text.secondary" paragraph>
                    Your payment was cancelled. No charges were made.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/pricing')}
                >
                    Return to Pricing
                </Button>
            </Box>
        </Container>
    );
};